import * as React from "react";
import styled, { css } from "styled-components";
import { Field } from "formik";
import AbsoluteDatePicker from "views/components/time-range-picker/AbsoluteDatePicker";
import AbsoluteTimeInput from "views/components/time-range-picker/AbsoluteTimeInput";
const ErrorMessage = styled.span(
  ({ theme }) => css`
    color: ${theme.colors.variant.dark.danger};
    font-size: ${theme.fonts.size.small};
    font-style: italic;
    padding: 3px 3px 9px;
    height: 1.5em;
  `
);
const AbsoluteCalendarInput = ({
  startDate = void 0,
  nextTimeRange,
  range,
  disableTimeMinute = false,
  disableTimeSecond = false
}) => /* @__PURE__ */ React.createElement(Field, { name: `nextTimeRange[${range}]` }, ({ field: { value, onChange, name }, meta: { error } }) => {
  const _onChange = (newValue) => onChange({ target: { name, value: newValue } });
  const dateTime = error ? nextTimeRange[range] : value || nextTimeRange[range];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(AbsoluteDatePicker, { onChange: _onChange, startDate, dateTime }), /* @__PURE__ */ React.createElement(
    AbsoluteTimeInput,
    {
      onChange: _onChange,
      dateTime,
      disableMinute: disableTimeMinute,
      disableSecond: disableTimeSecond,
      range
    }
  ), /* @__PURE__ */ React.createElement(ErrorMessage, null, error));
});
export default AbsoluteCalendarInput;
